export class GroupFacade {
    constructor(sdk) { this.sdk = sdk; }
    async info(contractId, groupContractPosition) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getGroupInfo(contractId, groupContractPosition);
    }
    async infoWithProof(contractId, groupContractPosition) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getGroupInfoWithProofInfo(contractId, groupContractPosition);
    }
    async infos(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getGroupInfos(query);
    }
    async infosWithProof(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getGroupInfosWithProofInfo(query);
    }
    async members(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getGroupMembers(query);
    }
    async membersWithProof(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getGroupMembersWithProofInfo(query);
    }
    async identityGroups(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityGroups(query);
    }
    async identityGroupsWithProof(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityGroupsWithProofInfo(query);
    }
    async actions(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getGroupActions(query);
    }
    async actionsWithProof(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getGroupActionsWithProofInfo(query);
    }
    async actionSigners(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getGroupActionSigners(query);
    }
    async actionSignersWithProof(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getGroupActionSignersWithProofInfo(query);
    }
    async groupsDataContracts(dataContractIds) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getGroupsDataContracts(dataContractIds);
    }
    async groupsDataContractsWithProof(dataContractIds) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getGroupsDataContractsWithProofInfo(dataContractIds);
    }
    async contestedResources(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getContestedResources(query);
    }
    async contestedResourcesWithProof(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getContestedResourcesWithProofInfo(query);
    }
    async contestedResourceVotersForIdentity(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getContestedResourceVotersForIdentity(query);
    }
    async contestedResourceVotersForIdentityWithProof(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getContestedResourceVotersForIdentityWithProofInfo(query);
    }
}
